<template>
  <div>
    <template v-if="editable">
      <b-row class="d-flex flex-wrap align-items-center">
        <b-col class="text-center" :cols="5" v-if="question.image != 0">
          <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
        <b-col :cols="((question.image == '0') ? 10 : 5)"><div v-html="question.content.replace(/&nbsp;/g, '')" class="question__content"></div></b-col>
        <b-col class="text-center" :cols=2>
          <span
            v-for="(answer) in question.answers"
            :key="answer.id"
          >
            <b-button
              pill
              variant="light"
              :class="'mx-1 btn__exam' + ((isSelected === answer.id) ? ' btn__exam--selected' : '') + ((answer.content == '对') ? ' answer__yes' : ' answer__no')"
              @click="selectAnswer(answer.id)"
            >
              <fa-icon v-if="answer.content == '对'" icon="check"></fa-icon>
              <fa-icon v-else icon="times"></fa-icon>
              &nbsp;<span v-html="answer.content"></span>
            </b-button>
          </span>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row class="d-flex flex-wrap align-items-center">
        <b-col class="text-center" :cols="5" v-if="question.image != 0">
          <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
        <b-col :cols="((question.image == '0') ? 10 : 5)"><div v-html="question.content.replace(/&nbsp;/g, '')" class="question__content" style="margin-left:10px;"></div></b-col>
        <b-col class="text-center" :cols=2>
          <span
            v-for="(answer) in question.answers"
            :key="answer.id"
          >
            <template v-if="answer.is_answer">
              <b-button
                pill
                variant="light"
                :class="'mx-1 btn__exam btn__exam--right'"
              >
                <fa-icon v-if="answer.content == '对'" icon="check"></fa-icon>
                <fa-icon v-else icon="times"></fa-icon>
                &nbsp;<span v-html="answer.content"></span>
              </b-button>
            </template>
            <template v-else>
              <b-button
                pill
                variant="light"
                :class="'mx-1 btn__exam' + ((response && response.answer_id === answer.id) ? ' btn__exam--exam_no' : '')"
              >
                <fa-icon v-if="answer.content == '对'" icon="check"></fa-icon>
                <fa-icon v-else icon="times"></fa-icon>
                &nbsp;<span v-html="answer.content"></span>
              </b-button>
            </template>
          </span>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionReadingBoolean',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false
    }
  },
  methods: {
    selectAnswer(a_id) {
      this.isSelected = a_id;

      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer_id: a_id
      })
    }
  }
}
</script>